export const processMetricChanges = (
  newValues: Record<string, any>,
  currentFilters: Record<string, any>
) => {
  const isMetricNameChange =
    newValues.metric_name !== currentFilters?.metric_name;

  const processedValues = isMetricNameChange
    ? { ...newValues, metric_value: undefined }
    : newValues;

  return {
    processedValues,
    isMetricNameChange,
  };
};

export const getChangedFields = (
  newValues: Record<string, any>,
  currentValues: Record<string, any>
): string[] => {
  return Object.keys(newValues).filter(
    key => newValues[key] !== currentValues?.[key]
  );
};

export const hasImmediateChanges = (
  changedFields: string[],
  newValues: Record<string, any>,
  currentValues: Record<string, any>,
  shouldUpdateImmediately: (field: string, newVal: any, oldVal: any) => boolean
): boolean => {
  return changedFields.some(field =>
    shouldUpdateImmediately(field, newValues[field], currentValues?.[field])
  );
};

export const handleAPIUpdateStrategy = (
  finalValues: Record<string, any>,
  isImmediate: boolean,
  isMetricNameChange: boolean,
  debouncedSetFilters: {
    cancel: () => void;
    (values: Record<string, any>): void;
  },
  setAPIFilters: (values: Record<string, any>) => void
) => {
  if (isImmediate || isMetricNameChange) {
    debouncedSetFilters.cancel();
    setAPIFilters(finalValues);
    return true;
  } else {
    debouncedSetFilters(finalValues);
    return false;
  }
};
